import React from 'react';
import classnames from 'classnames';
import styles from './loading-spinner.scss';
const Spinner = _ref => {
  let {
    className
  } = _ref;
  return /*#__PURE__*/React.createElement("div", {
    "data-hook": "loading-spinner-circle",
    className: classnames(className, styles.circle)
  });
};
export default Spinner;
//# sourceMappingURL=loading-spinner.js.map